<template>
	<div class="clock-container">
        <img class="background" rel="preload" src="./background/brdige-2-background.png" />
        <div class="group">
            <p class="date">{{ date }}</p>
            <p class="clock">{{ clock }}</p>
        </div>
        <img class="foreground" rel="preload" src="./foreground/bridge-2-foreground.png" />
    </div>
</template>

<script>
	import moment from "moment";

	export default {
		name: 'BridgeClock',
		data() {
            return {
                clock:null,
                date:null
            }
		},
        mounted() {
            this.updateClock();
            this.interval = setInterval(this.updateClock, 1000);
        },
        unmounted() {
            clearInterval(this.interval);
        },
        methods: {
            updateClock() {
                this.clock = moment().format('H:mm')
                this.date = moment().format("MMM Do YY");
            }
        },
	}
</script>

<style scoped lang="scss">
    .clock-container {
        width: 400px;
        height: 400px;

        background: linear-gradient(180deg, #004BDC 0%, rgba(0, 75, 220, 0) 100%);
        position:relative;

        .background {
            width: 400px;
            position:absolute;
            bottom: 0;
        }

        .foreground {
            width: 400px;
            position:absolute;
            bottom: 0;
            z-index: 2;
        }

        .fade {
            position:absolute;
            bottom: 0;
            z-index: 3;
        }

        .group {
            display: flex;
            flex-direction: column;
            gap: 0px;
            padding-top: 64px;
            position: relative;
            z-index: 1;
        }

        .clock {
            margin: 0;
            font-family: Inter;
            font-size: 120px;
            font-weight: 500;
            line-height: 120px;
            letter-spacing: -0.05em;
            text-align: center;
            color: white;
        }

        .date {
            margin: 0;
            color: white;
            font-family: Inter;
            font-size: 24px;
            font-weight: 500;
            line-height: 24px;
            letter-spacing: -0.02em;
            text-align: center;
        }
    }
</style>
